<template>
    <div class="w-full flex flex-col items-center justify-center p-2 ">
      <!-- The post's one H1 (the visible title below is a section title, not a heading in most themes). -->
      <h1 v-if="title" class="sr-only">{{ title }}</h1>
      <ImageGrid :title="title" :images :colors sharable v-if="images.length > 0" :background-variant="2" />
    </div>


</template>

<script setup>

import ImageGrid from "@/components/ImageGrid.vue";
import {computed} from "vue";
import FramedContainer from "@/components/FramedContainer.vue";

const props = defineProps({
  images: Array,
  colors: Object,
  title: String
})

const cssVars = computed(() => ({
  "--bg-light-variant-1": props.colors.whitest,
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-light-variant-3": props.colors.light,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--link-color": props.colors.accent,
  "--link-hover-color": props.colors.accentDark
}));

</script>


<style scoped>

</style>